import { AppData, Registry, Router } from '@lightningjs/sdk';
import { BrazeMessage } from 'types/braze';

export type DisplayType = 'fullscreen' | 'notification';

export type MessageCallbackProps = {
  message: BrazeMessage; // supporting only Braze for now
  displayType: DisplayType;
  onViewed: () => void;
  onButtonClick: (index: number) => void;
};

const SHOW_NOTIFICATION_RETRY_DELAY = 1000;

export default class NotificationService {
  private _isDisplaying = false;
  private _blockingElements = 0;

  private _showNotificationTimeout?: number;

  addBlockingElement() {
    this._blockingElements++;
  }

  removeBlockingElement() {
    this._blockingElements = Math.max(this._blockingElements - 1, 0);
  }

  resetBlockingElements() {
    this._blockingElements = 0;
  }

  show(modalName: keyof Router.Widgets, messageProps?: MessageCallbackProps) {
    // Only trigger when the page is settled. This prevents the notification getting closed by beforeEachRoute
    if (Router.isNavigating()) {
      Registry.clearTimeout(this._showNotificationTimeout);
      this._showNotificationTimeout = Registry.setTimeout(() => {
        this.show(modalName, messageProps);
      }, SHOW_NOTIFICATION_RETRY_DELAY);
      return;
    }
    this.showNotification(modalName, messageProps);
  }

  hide() {
    if (!this._isDisplaying) return;
    AppData?.modalService.close();
    this._isDisplaying = false;
  }

  private showNotification(
    modalName: keyof Router.Widgets,
    messageProps?: MessageCallbackProps,
  ) {
    if (!this.canShow()) return;
    AppData?.modalService.open(modalName, {
      openModalAboveCurrent: true,
      data: messageProps,
    });
    this._isDisplaying = true;
  }

  private canShow(): boolean {
    return (
      !this._isDisplaying &&
      this._blockingElements === 0 &&
      !AppData?.modalService.isBlockingModalActive()
    );
  }
}
